<template>
  <div class="project-appoint" id="project-appoint">
    <appoint-search
      shape="round"
      placeholder="请输入关键词"
      @search="onSearch"
      @clear="onClear"
    />
    <div class="project-appoint-box">
      <no-data v-if="list.length == 0"></no-data>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          class="project-list"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="list-item-box" v-for="(item, index) in list" :key="index">
            <div class="box-top" v-if="!improtStatus">
              <appoint-checkbox
                shape="square"
                v-model="item.checked"
                @click="itemChecked()"
              ></appoint-checkbox>
              <van-button class="btn" round @click="appointProject(item)"
                >项目委托</van-button
              >
            </div>
            <div class="box-content">
              <div
                :class="column.key == 'GJXMBH' ? 'projext-number' : 'cell-box'"
                v-for="column of columns"
                :key="column.key"
              >
                <span class="cell-title">{{ column.label }}</span>
                <div class="cell-value">{{ item[column.key] }}</div>
              </div>
            </div>
            <div class="box-buttom" v-if="improtStatus">
              <van-button class="btn" round @click="improtProject(item)"
                >导入该项目</van-button
              >
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <div class="project-footer" v-if="!improtStatus">
        <div class="project-footer-content">
          <appoint-checkbox
            class="checkbox"
            v-model="allChecked"
            @click="handleAllChecked()"
            >全选</appoint-checkbox
          >
          <van-button class="btn" round @click="importProject"
            >导入工建项目</van-button
          >
          <van-button
            round
            :class="allChecked ? 'delete-btn' : 'no-delete-btn'"
            @click="deleteProject"
            >删除工建项目</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
import appointCheckbox from '@/components/ProjectAppoint/appoint-checkbox'
import appointSearch from '@/components/ProjectAppoint/appoint-search'
import commonApi from '@/utils/api/common'
import api from '@/utils/api/appoint'
import {mapMutations} from 'vuex'

export default {
  components: {appointCheckbox, appointSearch, NoData},
  name: 'ProjectAppointHome',
  props: {},
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      searchValue: '',
      allChecked: false,
      improtStatus: false,
      columns: [],
      currentPage: 1,
      refreshing: false
    }
  },
  computed: {
    navTitle() {
      return this.improtStatus ? '导入工建项目选择' : '测绘项目委托'
    }
  },
  watch: {
    improtStatus: {
      handler(val) {
        console.log('----val:', val)
        if (val == true) {
          this.prevent_back()
        } else {
          this.remove_back()
        }
      }
    }
  },
  methods: {
    ...mapMutations('form', ['setFormData']),
    onLoad() {
      this.fetchGcjsxmList()
    },
    handleAllChecked() {
      this.list.forEach(item => {
        this.$set(item, 'checked', this.allChecked)
      })
    },
    itemChecked() {
      let isAllSelect = false
      this.list.forEach(item => {
        console.log(item.checked)
        if (item.checked) {
          isAllSelect = true
        }
      })
      this.allChecked = isAllSelect
    },
    onRefresh() {
      this.currentPage = 1
      this.list = []
      this.finished = false
      this.loading = false
      this.fetchGcjsxmList()
    },
    onSearch(val) {
      this.searchValue = val
      this.onRefresh()
    },
    onClear() {
      this.searchValue = ''
      this.onRefresh()
    },
    deleteProject() {
      let item = []
      this.list.forEach(i => {
        if (i.checked) {
          item.push(i.RID)
        }
      })
      if (item.length > 1) {
        this.$toast({
          icon: 'warning-o',
          message: '只能单项删除'
        })
        return
      }
      console.log('delete-rid', item)
      if (this.allChecked) {
        this.$dialog
          .confirm({
            className: 'dialog',
            title: '确定删除选中事项？',
            confirmButtonColor: '#1D84FF',
            cancelButtonColor: '#333333',
            width: '250'
          })
          .then(() => {
            api
              .deleteGcjsxmxx(item)
              .then(res => {
                //删除成功显示  删除成功！
                this.$toast({
                  icon: 'success',
                  message: res
                })
                this.allChecked = false
                this.onRefresh()
                console.log('deleteProject', res)
              })
              .catch(err => {
                console.log('err Project', err.response.data)
                this.$notify({
                  type: 'warning',
                  message: err.response.data.msg
                })
              })
          })
      }
    },
    importProject() {
      this.improtStatus = true
    },
    improtProject(item) {
      this.$dialog
        .confirm({
          className: 'dialog',
          title: '确定导入选中事项？',
          confirmButtonColor: '#1D84FF',
          cancelButtonColor: '#333333',
          width: '250'
        })
        .then(() => {
          let imp = []
          imp.push(item.RID)
          api
            .importGcjsxmxx(imp)
            .then(res => {
              //成功
              this.onRefresh()
              this.$toast({
                icon: 'success',
                message: res
              })
              history.go(-1) //等于按钮返回按钮
              //   this.improtStatus = false
              console.log('improtProject', res)
            })
            .catch(err => {
              console.log('err Project', err.response.data)
              this.$notify({
                type: 'warning',
                message: err.response.data.msg
              })
            })
        })
    },
    appointProject(item) {
      let data = JSON.parse(JSON.stringify(item)) //深拷贝，不然会删除列表显示的参数
      //  let data = item
      for (let key in data) {
        switch (key) {
          case 'GJXMBH':
            data['GGXMBH'] = data['GJXMBH']
            delete data['GJXMBH']
            break
          case 'GJXMMC':
            data['XMMC'] = data['GJXMMC']
            delete data['GJXMMC']
            break
          case 'XMDD':
            data['GCXXDD'] = data['XMDD']
            delete data['XMDD']
            break
          case 'DWMC':
            data['JSDW'] = data['DWMC']
            delete data['DWMC']
            break
        }
      }
      this.setFormData(data)
      //  this.$store.state.formData = data
      this.$router.push({
        name: 'ProjectAppointDetail',
        params: {
          rid: item.RID,
          type: 2
          // rid: '46f656db-edae-4e6f-ac86-ffcbbc930ca6',
          // type: 1
          //1是更新，2是创建
        }
      })
    },
    fetchGcjsxmList() {
      this.loading = true
      let params = {
        page: this.currentPage,
        rows: 10,
        gjxmtydm: this.$store.state.userInfo
          ? this.$store.state.userInfo.Usco
          : '91130629MA0FTGDK9N',
        type: 2,
        search: {
          key: '',
          value: this.searchValue
        }
      }
      commonApi.getGcjsxmList(params).then(res => {
        setTimeout(() => {
          this.loading = false
          this.refreshing = false
          this.columns = res.columns
          if (res.rowsList) {
            if (this.currentPage == 1) {
              this.list = res.rowsList
            } else {
              this.list.push(...res.rowsList)
            }
            this.currentPage++
            // for (let index = 0; index < res.rowsList.length; index++) {
            //   const element = res.rowsList[index]
            //   this.list.push(element)
            // }
            this.finished = this.list.length >= res.total
            // if (res.rowsList.length == 0) {
            //   this.finished = true
            // }
          }
        }, 500)
      })
    },
    pushStateFun() {
      this.improtStatus = false
    },
    prevent_back() {
      let path = this.$route.fullPath
      // 判断是否开启了后端支持
      if (this.$router.mode == 'hash') {
        path = '#' + path
      }
      var state = {
        title: null,
        url: path //要禁掉的页面
      }
      window.history.pushState(state, null, path) //要禁掉的页面
      window.addEventListener('popstate', this.pushStateFun, false)
    },
    remove_back() {
      window.removeEventListener('popstate', this.pushStateFun, false)
    }
  },
  created() {},
  mounted() {
    this.fetchGcjsxmList()
    this.$bus.$off('onRefresh')
    this.$bus.$on('onRefresh', () => {
      this.$nextTick(() => {
        this.onRefresh()
      })
    })
  }
}
</script>
<style lang="scss" scoped>
.project-appoint {
  background: #f0f3f6;
  .projectSearch {
    position: fixed;
    width: 100%;
    top: 0;
  }
  .project-list {
    margin-bottom: 60px;
  }
  .list-item-box {
    margin: 16px;
    background: #ffffff;
    box-shadow: 0px 2px 5px 0px rgba(124, 130, 140, 0.2);
    border-radius: 5px;
    .box-top {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 15px;
      border-bottom: 1px solid #f1f3f6;
    }
    .box-content {
      padding: 18px 20px 30px 15px;
      .projext-number {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        display: flex;
        justify-content: center;
        line-height: 20px;
        .cell-title {
          width: 30%;
          text-align: right;
        }
        .cell-value {
          width: 70%;
          display: inline-block;
          padding-left: 18px;
          vertical-align: text-bottom;
        }
      }
      .cell-box {
        display: flex;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        margin-top: 14px;
        .cell-title {
          width: 30%;
          color: #999999;
          text-align: right;
        }
        .cell-value {
          width: 70%;
          padding-left: 18px;
          color: #333333;
          line-height: 21px;
        }
      }
    }
    .box-buttom {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0px 15px;
      border-top: 1px solid #f1f3f6;
    }
  }
  .project-footer {
    height: 60px;
    background: #ffffff;
    bottom: 0;
    position: fixed;
    width: 100%;
    .project-footer-content {
      display: flex;
      height: 100%;
      align-items: center;
      padding-left: 30px;
      .checkbox {
        ::v-deep .van-checkbox__label {
          font-size: 14px;
          font-weight: 500;
          color: #333333;
        }
      }
      & .btn {
        margin-left: 35px;
        margin-right: 15px;
      }
    }
  }
  .btn {
    background: #0086ff;
    box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    padding: 7px 12px;
    height: auto;
    display: inline-block;
    border: 1px solid transparent;
  }
  .delete-btn {
    background: #ff2b32;
    box-shadow: 0px 2px 6px 0px rgba(255, 43, 50, 0.5);
    height: auto;
    font-size: 14px;
    padding: 7px 12px;
    font-weight: 500;
    color: #ffffff;
    border: 1px solid transparent;
  }
  .no-delete-btn {
    background: #cfcfcf;
    box-shadow: 0px 2px 6px 0px rgba(207, 207, 207, 0.5);
    height: auto;
    padding: 7px 12px;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    border: 1px solid transparent;
  }
}
</style>
